// External Dependencies
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Avatar from 'material-ui/Avatar';
import Paper from 'material-ui/Paper';
import {
  Step,
  StepButton,
  StepContent,
  Stepper,
} from 'material-ui/Stepper';

// Internal Dependencies
import connectComponent from '../connect-component';
import CoderCardBadgeList from './CoderCardBadgeList';
import {
  fetchCoderSingle,
} from '../state/actions/coder-single-actions';
import styles from '../styles/Styles';

// Local Variables
const propTypes = {
  badges: PropTypes.arrayOf(PropTypes.object),
  coderSingle: PropTypes.object,
  onFetchCoderSingle: PropTypes.func,
  params: PropTypes.object,
};

const avatarStyles = { padding: 10 };

// Component definition
class CoderDetailsPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      stepIndex: 0,
    };
  }

  componentDidMount() {
    this.key = this.props.params.key;
    this.props.onFetchCoderSingle(this.key);
  }

  handleNext = () => {
    const {
      stepIndex,
    } = this.state;

    if (stepIndex < 2) {
      this.setState({
        stepIndex: stepIndex + 1,
      });
    }
  };

  handleClickAchievements = () => this.setState({ stepIndex: 0 });
  handleClickAttendance = () => this.setState({ stepIndex: 1 });

  handlePrev = () => {
    const { stepIndex } = this.state;
    if (stepIndex > 0) {
      this.setState({
        stepIndex: stepIndex - 1,
      });
    }
  };

  render() {
    const {
      badges,
      coderSingle,
    } = this.props;
    const {
      stepIndex,
    } = this.state;

    const paramKey = this.props.params.key;
    const thisStyle = styles.coderDetailsPage;

    const image = `${window.location.pathname}images/ninja-face.svg`;
    const timeIcon = `${window.location.pathname}images/calendar.svg`;
    const trophyIcon = `${window.location.pathname}images/trophy.png`;

    const options = {
      weekday: 'long',
      year: 'numeric',
      month: 'long',
      day: 'numeric',
    };

    if (!coderSingle.attendance) return null;

    return (
      <section style={thisStyle.mainSection}>
        <div style={thisStyle.ProfileCoderDetails}>
          <Paper style={thisStyle.ProfileAvatar} zDepth={3} circle>
            <Avatar
              src={image}
              size={190}
              style={avatarStyles}
              backgroundColor="#fff"
            />
          </Paper>

          <div style={thisStyle.ProfileNameText}>
            {coderSingle.firstName}&nbsp;
            {coderSingle.lastName.charAt(0)}.
          </div>

          <div style={thisStyle.textStyle}>
            {coderSingle.title}
          </div>
        </div>

        <div style={thisStyle.activitySection}>
          <div style={thisStyle.stepperSection}>
            <Stepper activeStep={stepIndex} linear={false} orientation="vertical">
              <Step>
                <StepButton
                  onClick={this.handleClickAchievements}
                  icon={
                    <Avatar
                      src={trophyIcon}
                      size={20}
                      style={thisStyle.stepperAvatar}
                      backgroundColor={thisStyle.avatarBGColor}
                    />
                  }
                >
                  <div style={thisStyle.stepperText}>ACHIEVEMENTS</div>
                </StepButton>
                <StepContent>
                  <div style={thisStyle.badgesListDiv}>
                    <CoderCardBadgeList
                      badges={badges}
                      coderBadges={coderSingle.badges}
                      coderKey={paramKey}
                      key={paramKey}
                      size={thisStyle.badgeSize}
                      details="true"
                    />
                  </div>
                </StepContent>
              </Step>
              <Step>
                <StepButton
                  onClick={this.handleClickAttendance}
                  icon={
                    <Avatar
                      src={timeIcon}
                      size={20}
                      style={thisStyle.stepperAvatar}
                      backgroundColor={thisStyle.avatarBGColor}
                    />
                  }
                >
                  <div style={thisStyle.stepperText}>ACTIVITY LOG</div>
                </StepButton>
                <StepContent>
                  {Object.keys(coderSingle.attendance).map((key, index) => (
                    <div key={index} style={thisStyle.attendanceListDiv}>
                      <div style={thisStyle.dateText}>
                        - {(new Date(coderSingle.attendance[key])).toLocaleDateString('en-US', options)}
                      </div>
                    </div>
                  ))}
                </StepContent>
              </Step>
            </Stepper>
          </div>
        </div>
      </section>
    );
  }
}

CoderDetailsPage.propTypes = propTypes;
export default connectComponent(state => ({
  badges: state.badges,
  coderSingle: state.coderSingle,
}), {
  onFetchCoderSingle: fetchCoderSingle,
}, CoderDetailsPage);



/** WEBPACK FOOTER **
 ** ./src/ninjas/CoderDetailsPage.js
 **/